class TabsLinks {
    tabs = document.querySelectorAll(".js-tabs");

    constructor(el) {
        this.el = el;
        this.toggleVisibleLinkTabs();
    }

    toggleVisibleLinkTabs() {
        if (!this.tabs.length) {
            return;
        }
        this.tabs.forEach(tab => {
            const tabNavs = tab.querySelectorAll(".js-tabs-item");
            const tabLinks = tab.querySelectorAll(".js-tabs-link");

            tabNavs.forEach((tabNav) => {
                tabNav.addEventListener("click", e => {
                    e.preventDefault();
                    const activeTabAttr = e.target.getAttribute("data-tab");

                    tabLinks.forEach((tabLink, index) => {
                        const linkAttr = tabLinks[index].getAttribute("data-tab-link");

                        if (activeTabAttr === linkAttr) {
                            tabLinks[index].classList.remove("hidden"); 
                        } else {
                            tabLinks[index].classList.add("hidden");
                        }
                    })                
                })
            })
        })
    }
}

window.addEventListener(
    "load",
    document
        .querySelectorAll(".js-press-center-news")
        .forEach(node => new TabsLinks(node))
);